import { useCallback } from 'react';

const LOGIN_PATH = import.meta.env.LOGIN_PATH || '/backend/api/auth/login';
const REDIRECT_URI_PARAM_NAME =
  import.meta.env.REDIRECT_URI_PARAM_NAME || 'clientRequestedUrl';
const AUTHORIZATION_ERROR_PARAM_NAME =
  import.meta.env.AUTHORIZATION_ERROR_PARAM_NAME || 'authorizationError';

export const useGotoLogin = () =>
  useCallback((returnUrl = '/', error?: string) => {
    if (!LOGIN_PATH) {
      throw new Error('LOGIN_PATH is not defined! Please set it in .env');
    }
    if (!LOGIN_PATH.startsWith('/')) {
      throw new Error(
        `LOGIN_PATH must begin with a slash but got "${LOGIN_PATH}"`
      );
    }

    let url = LOGIN_PATH;

    if (returnUrl || error) {
      url += '?';
      const params = new URLSearchParams();

      if (error) {
        params.set(AUTHORIZATION_ERROR_PARAM_NAME, error);
      }

      if (returnUrl) {
        params.set(REDIRECT_URI_PARAM_NAME, returnUrl);
      }

      url += params.toString();
    }

    window.location.href = url;
  }, []);
